import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
const sellingPoints = [{
  emoji: '🎂',
  title: 'Cumpleaños infantiles',
  description: 'Candy bar temáticos que se venden solos'
}, {
  emoji: '🎉',
  title: 'Fiestas de 15',
  description: 'Eventos con alto consumo y ticket elevado'
}, {
  emoji: '💍',
  title: 'Casamientos',
  description: 'Mesas dulces premium con gran margen'
}, {
  emoji: '🍼',
  title: 'Baby showers',
  description: 'Pedidos personalizados y recurrentes'
}, {
  emoji: '🎈',
  title: 'Bautismos y comuniones',
  description: 'Eventos familiares con alta demanda'
}, {
  emoji: '🏢',
  title: 'Eventos corporativos',
  description: 'Regalos empresariales y ventas por volumen'
}, {
  emoji: '🎓',
  title: 'Egresos',
  description: 'Fiestas con consumo masivo'
}, {
  emoji: '🏫',
  title: 'Kioscos escolares',
  description: 'Venta diaria y constante'
}, {
  emoji: '🎁',
  title: 'Regalos personalizados',
  description: 'Fechas especiales y pedidos únicos'
}, {
  emoji: '🎄',
  title: 'Fechas clave',
  description: 'Navidad, Día del Niño, Mundial y temporadas altas'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.06
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
      ease: 'easeOut'
    }
  }
};
export function SellingPoints() {
  return <section className="py-20 bg-gradient-to-b from-palomitas-dark via-[#2a1f18] to-palomitas-dark relative overflow-hidden" data-id="element-238">
      {/* Decorative blobs */}
      <div className="absolute top-10 left-[-5%] w-80 h-80 bg-palomitas-coral/10 rounded-full blur-3xl" data-id="element-239" />
      <div className="absolute bottom-10 right-[-5%] w-80 h-80 bg-palomitas-gold/10 rounded-full blur-3xl" data-id="element-240" />

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-241">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-242">
          <span className="inline-block bg-palomitas-gold/20 text-palomitas-gold px-5 py-2 rounded-full font-bold text-sm uppercase tracking-wide mb-5 border border-palomitas-gold/30" data-id="element-243">
            🍿 Oportunidades de venta
          </span>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-244">
            ¿Dónde podés vender{' '}
            <span className="text-palomitas-gold" data-id="element-245">Palomitas Gourmet</span>?
          </h2>
          <p className="text-lg md:text-xl text-white/70 max-w-2xl mx-auto" data-id="element-246">
            Convertí cualquier evento en una oportunidad de ingreso
          </p>
        </motion.div>

        {/* Checklist */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-3xl mx-auto" data-id="element-247">
          {sellingPoints.map((point, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-3 bg-white/5 border border-white/10 rounded-xl px-5 py-4" data-id="element-248">
              <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-249">✅</span>
              <div data-id="element-250">
                <p className="text-white font-bold text-base leading-tight" data-id="element-251">
                  {point.emoji} {point.title}
                </p>
                <p className="text-white/55 text-sm mt-0.5 leading-snug" data-id="element-252">
                  {point.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>

        {/* Bottom highlight block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-14 text-center" data-id="element-253">
          <div className="inline-block bg-gradient-to-r from-palomitas-gold/20 via-palomitas-gold/10 to-palomitas-gold/20 border border-palomitas-gold/30 rounded-2xl px-8 py-6 mb-8" data-id="element-254">
            <p className="text-xl md:text-2xl font-bold text-white" data-id="element-255">
              💰 Un solo producto,{' '}
              <span className="text-palomitas-gold" data-id="element-256">múltiples formas</span> de
              generar ingresos
            </p>
          </div>

          <div className="flex justify-center" data-id="element-257">
            <Button href="#oferta" className="text-lg md:text-xl px-10 py-5 !bg-green-600 hover:!bg-green-700 !text-white shadow-2xl shadow-green-900/30 font-bold uppercase tracking-wide" data-id="element-258">
              🚀 QUIERO EMPEZAR AHORA
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}